import { MaskType } from '~/models/Common';

export default function convertMaskToInputMask(mask: string): MaskType {
  const arr = mask.split('');
  const arrRegExp = arr.map((x) => (/9/.test(x) ? /[0-9]/ : x));

  return arrRegExp;
}
